import React from 'react'
import { Link } from 'react-router-dom';
import './styles/Bilder.css'
import { useEffect, useState } from 'react';
import "react-multi-carousel/lib/styles.css";
import { MdLockOutline } from "react-icons/md"
import PasswordDialog from './Components/PasswordDialog';


export default function Bilder() {
    const [yearStyleProps, setYearStyleProps] = useState([]);
    const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
    const [year, setYear] = useState();

    const [years, setYears] = useState([]);
    const [albums, setAlbums] = useState([]);

    //on page load
    useEffect(() => {
        loadAlbums();
    }, []);

    //fetch album data from db, set initial style props
    const loadAlbums = async () => {
        const dev = false;
        let api_url = "";

        if (dev) {
            api_url = "http://localhost:90/public/api/getAlbums.php";
        } else {
            api_url = "/api/getAlbums.php"
        }

        fetch(api_url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            const albums = data.data;
            console.log(albums);
            const years = [...new Set(data.data.map(item => item.albumYear))].sort((a, b) => b - a);
            setAlbums(albums);
            setYears(years);

            const yearStylePropsCopy = years.map(year => ({
                year: year,          
                albumOpacity: 0.3,
                albumPointerEvents: 'none',
                lockiconVisibility: 'visible'
            }));
            setYearStyleProps(yearStylePropsCopy);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    const openAlbum = async (albumId) => {
        const dev = false;
        let api_url = "";

        if (dev) {
            api_url = "http://localhost:90/public/api/getAlbumLink.php?albumId=" + albumId;
        } else {
            api_url = "/api/getAlbumLink.php?albumId=" + albumId;
        }

        fetch(api_url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            const albumLink = data.data[0].albumLink;
            console.log(albumId);
            console.log(data);
            console.log(albumLink);
            window.open(albumLink, '_blank');
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    //opens password dialog to unlock albums
    const unlockAlbums = (year) => {
        setYear(year);
        setPasswordDialogOpen(true);
    }

    //handle success of password dialog
    const handlePasswordDialogSucess = (year) => {
        setPasswordDialogOpen(false);

        let yearStylePropsCopy = yearStyleProps.slice();
        yearStylePropsCopy.map((yearStyleProp, index) => {
            if (yearStyleProp.year === year) {
                yearStyleProp.albumOpacity = 1;
                yearStyleProp.albumPointerEvents = 'auto';
                yearStyleProp.lockiconVisibility = 'hidden';
            }
        });
        setYearStyleProps(yearStylePropsCopy);
    }

    //handle close of password dialog
    const handlePasswordDialogClose = () => {
        setPasswordDialogOpen(false);
    }
    

    return (
        <div className='picturesContainer'>
            <PasswordDialog open={passwordDialogOpen} handleSuccess={() => handlePasswordDialogSucess(year)} handleClose={handlePasswordDialogClose} year={year}/>
            <div className='picturesContentContainer'>
                <div className='picturesTextContainer'>
                    <h1>Bilder</h1>
                    <p>Hier findestet du die Bilder der vergangenen Jahre.</p>
                </div>

                <div className='picturesYearsContainer'>
                    {
                        years.map((year, yearIndex) => {
                            return(
                                <div key={year} className='picturesYearContainer'>
                                    <div className='picturesYearHeadContainer'>
                                        <h2 className='picturesYearHeadText'>{year}</h2>
                                        <MdLockOutline className='picturesLockIcon' size={(25, 25)} style={{visibility: yearStyleProps.find(item => item.year === year).lockiconVisibility}} onClick={() => unlockAlbums(year, yearIndex)}/>
                                    </div>
                                    <div className='picturesYearAlbumContainer'>
                                        <div className='picturesYearOpenAlbumContainer'>
                                            {
                                                albums.map((album, albumIndex) => {
                                                    if (album.albumYear === year && album.protected === 0) {
                                                        return(
                                                            <div key={album.albumId} className='picturesYearOpenImageContainer' onClick={() => openAlbum(album.albumId)}>
                                                                <img 
                                                                    src={album.albumThumbPath} 
                                                                    alt={album.albumName} 
                                                                    className='picturesYearThumbnail'
                                                                />
                                                                <p>{album.albumName}</p>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                        <div 
                                            className='picturesYearLockedAlbumContainer' 
                                            style={{
                                                opacity: yearStyleProps.find(item => item.year === year).albumOpacity,
                                                pointerEvents: yearStyleProps.find(item => item.year === year).albumPointerEvents
                                            }}
                                        >
                                            {
                                                albums.map((album, albumIndex) => {
                                                    if (album.albumYear === year && album.protected === 1) {
                                                        return(
                                                            <div key={album.albumId} className='picturesYearLockedImageContainer' onClick={() => openAlbum(album.albumId)}>
                                                                <img 
                                                                    src={album.albumThumbPath}
                                                                    alt={album.albumName} 
                                                                    className='picturesYearThumbnail'
                                                                />
                                                                <p>{album.albumName}</p>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>


            <div className='picturesBottomContainer'>
                <Link to='https://deutsche-schreberjugend.de/'>
                    <p> Deutsche Schreberjugend</p>
                </Link>
                <Link to={'/impressum'}>
                    <p>Impressum</p>
                </Link>
                <Link to={'/datenschutz'}>
                    <p>Datensschutz</p>
                </Link>
            </div>

        </div> 
    )
}
